import React from 'react';
import { motion } from 'framer-motion';
import './ServicesShowcase.css';

const services = [
    'SPECIAL/REMEDIAL EDUCATION',
    'Occupational Therapy',
    'Speech Therapy',
    'Parent COUNSELLING',
    'IQ/EQ TESTS',
    'PERSONALITY TESTS',
    'OTHER PSYCHOLOGICAL TESTS'
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

export const ServicesShowcaseChild: React.FC = () => {
    return (
      <div className="services-section">
        <h2 className="services-title">A few things we’re great at</h2>
        <motion.ul
          className="services-list"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {services.map((service, index) => (
            <motion.li
              key={index}
              variants={itemVariants}
              className="service-item"
            >
              {service}
            </motion.li>
          ))}
        </motion.ul>
      </div>
    );
  };